import React from 'react'
import Nav from '../components/Nav'
import StackMain from '../components/StackMain'
import Letsconnect from '../components/Letsconnect'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

function Stack() {
  const stackData = [
    {
      title:'Flutter',
      subdescription:'Cross-Platform Mobile App Development',
      description:'An open-source UI software development kit created by Google. It is used to develop applications for Android, iOS, Linux, Mac, Windows, Google Fuchsia, and the web from a single codebase.',
      img:'https://cdn.worldvectorlogo.com/logos/flutter-logo.svg'

    },
  
    {
      title: 'Node.js',
      subdescription: 'Fast and Scalable Server-Side Applications',
      description: 'An open-source runtime environment that allows us to build high-performance server-side applications using JavaScript.   ',
      img: 'https://cdn.worldvectorlogo.com/logos/nodejs-icon.svg'
    }, 
    {
      title: 'Next.js',
      subdescription: 'Powerful React Framework for Server-Side Rendering',
      description: 'A React framework that enables server-side rendering and static site generation, optimizing performance and SEO.',
      img: 'https://cdn.worldvectorlogo.com/logos/next-js.svg'
    },
    {
     title: 'React',
     subdescription: 'Build Interactive User Interfaces',
     description: 'A popular JavaScript library for creating dynamic and responsive user interfaces, allowing for a seamless user experience.   ',
     img:'https://cdn.worldvectorlogo.com/logos/react-2.svg'
   },
    {
      title: 'Django',
      subdescription: 'High-Level Python Web Framework',
      description: 'A web framework that encourages rapid development and clean, pragmatic design, ideal for building secure and maintainable web applications.',
      img: 'https://cdn.worldvectorlogo.com/logos/django.svg'
    },
    {
      title:'Wagtail',
      subdescription:'Flexible Content Management System',
      description:'An open-source content management system built on Django, with a strong emphasis on user experience and flexibility. It is focused on flexibility and user experience.',
      img:'https://cdn.worldvectorlogo.com/logos/wagtail.svg'
    },
    {
      title: 'MongoDB',
      subdescription: 'Flexible NoSQL Database Solution',
      description: 'A document-oriented database that enables us to store and retrieve data in a flexible, scalable manner, perfect for handling large volumes of data.  ',
      img: 'https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg'
    },
    {
      title: 'PostgreSQL',
      subdescription: 'Advanced Relational Database Management',
      description: 'An open-source relational database that offers robust features and reliability for complex data structures and transactions.',
      img: 'https://cdn.worldvectorlogo.com/logos/postgresql.svg'
    },
    {
      title: 'Firebase',
      subdescription: 'Real-Time Database and Backend as a Service',
      description: 'A platform that offers real-time database capabilities, authentication, and hosting, making it easy to develop and deploy apps quickly.',
      img: 'https://cdn.worldvectorlogo.com/logos/firebase-1.svg'
    },
    {
      title:'Kotlin',
      subdescription:'Modern Programming Language for Android Development',
      description:'A cross-platform, statically typed, general-purpose programming language with type inference. It is designed to interoperate fully with Java, and the JVM version of its standard library depends on the Java Class Library.',
      img:'https://cdn.worldvectorlogo.com/logos/kotlin-1.svg'
    },
    {
      title:'Swift',
      subdescription:'Innovative Language for iOS App Development',
      description:'A general-purpose, multi-paradigm, compiled programming language developed by Apple Inc. and the open-source community, first released in 2014.',
      img:'https://cdn.worldvectorlogo.com/logos/swift-15.svg'
    },
   
    {
      title: 'GraphQL',
      subdescription: 'Flexible API Query Language',
      description: 'A query language for APIs that allows clients to request only the data they need, improving performance and efficiency.',
      img: 'https://cdn.worldvectorlogo.com/logos/graphql-logo-2.svg'
    },
    {
      title: 'Docker',
      subdescription: 'Containerization for Development and Deployment',
      description: 'A platform that enables developers to create, deploy, and run applications in containers, ensuring consistency across environments.',
      img: 'https://cdn.worldvectorlogo.com/logos/docker-4.svg'
    },
    {
      title:'Figma',
      subdescription:'Collaborative Interface Design Tool',
      description:'A web-based UI/UX design tool that enables real-time collaboration among team members, streamlining the design process.',
      img:'https://cdn.worldvectorlogo.com/logos/figma-icon.svg'
    },
   

  ]
  return (
    <div className="flex h-screen w-full">
    {/* Nav should take 20% of the width and remain fixed */}
    <div className="md:w-[20%] ">
      <Nav />
    </div>
    {/* The Hero content should take up the remaining 80% and be scrollable */}
    <div className="md:w-[80%]   md:px-16 md:pt-32 py-20 p-5">
    <div>
        <div className=' text-white  animate-slideUp text-2xl md:text-3xl font-medium text-opacity-90 mb-10'>
        Our Tech Toolbox
        </div>
        <div className=' flex flex-wrap gap-6'>
            {
            stackData.map((data,index)=>(
              <StackMain stack={{image:data.img,subdescription:data.subdescription,name:data.title,description:data.description,link:'/'}}/>
            ))
            }
        </div>
    </div>
    <Letsconnect/>
    <div className=' pb-4'>

     <Footer/>
     </div>
    </div>
  </div>
  )
}

export default Stack
